import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=a49ed26c&scoped=true&"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js&"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=a49ed26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49ed26c",
  null
  
)

export default component.exports